<template>
  <div class="infoMainBox">
    <div class="title pubTitle">{{dataForm.Title}}</div>
    <div class="time">{{dataForm.PublishTime}}</div>
    <div class="info" v-html="dataForm.Content"></div>
    <el-table style="width: 100%"
            :row-style="{height: '50px'}"
            :data="tableData"
            v-loading.body="tableLoading"
            element-loading-text="加载中..."
            stripe border fit highlight-current-row>
      <!--<el-table-column prop="orderNo" label="运单号" width="150" align="center"></el-table-column>-->
      <el-table-column prop="driver" label="司机" align="center"></el-table-column>
      <el-table-column prop="tel" label="手机号" align="center"></el-table-column>
      <el-table-column prop="state" label="评价状态" align="center"></el-table-column>
      <el-table-column prop="fen1" label="装货考核(25分)" align="center"></el-table-column>
      <el-table-column prop="fen2" label="途中考核(30分)" align="center"></el-table-column>
      <el-table-column prop="fen3" label="卸货考核(25分)" align="center"></el-table-column>
      <el-table-column prop="fen4" label="货主考核(20分)" align="center"></el-table-column>
      <el-table-column prop="fen5" label="综合评分(100分)" align="center"></el-table-column>
    </el-table>
    <div style="margin-bottom:15px;" class="info" v-html="dataForm.ContentTuiChu"></div>
    <div class="el-loading-mask" style="display: none;">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  export default {
    data(){
      return{
        tableLoading: false,
        dataForm:{
          ID:null,
          TypeId: null,
          PublishTime: null,
          Title: null,
          Content: null,
          Sort: null,
        },
        tableData:[
          {orderNo:'492803',driver:'杜*府',tel:'151****1156',state:'已评价',fen1:'23',fen2:'29',fen3:'24',fen4:'20',fen5:'96.0'},
          {orderNo:'530175',driver:'李*虎',tel:'187****1518',state:'已评价',fen1:'22',fen2:'28',fen3:'21',fen4:'22',fen5:'93.0'},
          {orderNo:'058839',driver:'杨*',tel:'152****9334',state:'已评价',fen1:'24',fen2:'26',fen3:'25',fen4:'20',fen5:'95.0'},
          {orderNo:'717920',driver:'杨*高',tel:'137****3853',state:'已评价',fen1:'25',fen2:'30',fen3:'23',fen4:'19',fen5:'97.0'},
          {orderNo:'393628',driver:'高*',tel:'150****9892',state:'已评价',fen1:'24',fen2:'27',fen3:'23',fen4:'19',fen5:'93.0'},
          {orderNo:'932287',driver:'胡*',tel:'189****7939',state:'已评价',fen1:'25',fen2:'29',fen3:'24',fen4:'19',fen5:'97.0'},
          {orderNo:'883305',driver:'张*洋',tel:'153****5674',state:'已评价',fen1:'24',fen2:'26',fen3:'25',fen4:'19',fen5:'94.0'},
          {orderNo:'486668',driver:'张*兵',tel:'139****3162',state:'已评价',fen1:'23',fen2:'28',fen3:'25',fen4:'20',fen5:'96.0'},
          {orderNo:'912662',driver:'张*伟',tel:'139****6055',state:'已评价',fen1:'21',fen2:'27',fen3:'25',fen4:'20',fen5:'93.0'},
          {orderNo:'548318',driver:'李*朝',tel:'130****8618',state:'已评价',fen1:'25',fen2:'28',fen3:'23',fen4:'18',fen5:'94.0'},
          {orderNo:'912662',driver:'陈*',tel:'139****6546',state:'已评价',fen1:'25',fen2:'30',fen3:'24',fen4:'19',fen5:'98.0'},
          {orderNo:'912662',driver:'李*其',tel:'183****9966',state:'已评价',fen1:'21',fen2:'28',fen3:'24',fen4:'19',fen5:'92.0'},

        ]
      }
    },
    methods:{
      InitNews(id){
        let _this = this
        if(id==1){
          _this.dataForm.Title=''
          _this.dataForm.PublishTime='2023-03-01 10:27'
          _this.dataForm.Content='嘉盈智慧物流秉承对实际承运人公平公正的信用评价体系，围绕装货考核、途中考核、卸货考核、货主考核进行综合考核评价，将评价结果在平台公示：'
          _this.dataForm.ContentTuiChu='<br/><b>承运人退出机制：</b>'
                                  +'<br/>1、单个自然月内，综合信用得分为60分以下的，暂停接单7天；'
                                  +'<br/>2、6个月内，累计3次月综合信用得分为60分以下的，列入黑名单；'
                                  +'<br/>3、接单后非承运人本人实际承运的，一经发现即被列入黑名单；'
                                  +'<br/>4、承运人及其所属车辆存在相关证件信息造假情型的，一经发现立即列入黑名单；'
                                  +'<br/>5、承运人进入交通运输部超载超限黑名单的；'
                                  +'<br/>6、承运人被法院列为失信被执行人的；'
                                  +'<br/>7、承运人发生重大交通事故，造成人员伤亡的，一经发现立即列入黑名单；'
                                  +'<br/>8、承运人存在酒后驾驶追逐竞驶的，一经发现立即列入黑名单；'
                                  +'<br/>9、承运人存在威胁恐吓收发货人的，一经发现立即列入黑名单；'
                                  +'<br/>10、承运人存在以不当得利手段侵害平台利益，一经发现立即列入黑名单；'
                                  +'<br/>11、散布虚假信息损害平台声誉，一经发现立即列入黑名单。'
        }
        
      }
    },
    mounted() {
      if (this.$route.query.id) {
        this.dataForm.ID = this.$route.query.id;
        this.InitNews(this.$route.query.id)
      }
    }
  };
</script>
<style>
  .pubTitle {
    text-align: center;
    margin:0 0 50px;
    padding-top: 50px;
    font-size: 30px;
  }
  .pubHoverImg {
    &:hover{
      transition: 0.5s width ease,0.5s height ease; 
      position: relative;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 105%;
      height: 105%;
      box-shadow: 0 0 10px rgba(0,0,0,0.2);
    }
  }
  .infoMainBox{width:1200px;margin:-40px auto 0}
  .infoMainBox .time{text-align:right;font-size:16px;color:#666;margin-bottom:10px}
  .infoMainBox img{
    width: 100%;
    height: 100%;
  }
  .info{ font-size:20px;}
</style>









// WEBPACK FOOTER //
// src/pages/CompanyDynamic/Detail.vue